import React, { useEffect, useMemo, useState } from 'react';
import { RndWrapper } from '../base/RndModal';
import ModalLayout from '../base/RndModal/ModalLayout';
import Header from '../ModelModal/Header';
import ContentWrapper from '../ModelModal/ContentWrapper';
import { currentChoosedMenuId, menuLevel, modalType } from '../../constants';
import LoraSideBar from './LoraSideBar';
import { useMenu } from '../../hooks/modelModal';
import { translate } from '@shakkerai/util-i18n';
import { useUnitData } from '@starflow/app/store';
import { setModelsModalState } from '../../store/state';

const LoraModels = React.memo(() => {
  const { baseType } = useUnitData();
  const [menus, setMenus] = useState([]);
  const menuList = useMenu(modalType.LORA);
  useEffect(() => {
    if (menuList?.length) {
      setMenus(menuList);
    }
  }, [menuList]);

  useEffect(() => {
    if (baseType) {
      setModelsModalState({
        baseTypes: [`${baseType}`],
      });
    }
  }, [baseType]);

  const menuPath = useMemo(() => {
    // 从外到里，减少遍历
    const findl1 = menus.find((m) => m.choosed);
    if (findl1?.tagLabel) {
      return {
        level: menuLevel.L0,
        menu: findl1,
      };
    }
    const findl2 = menus.find((a) => a.children && a.children.some((c) => c.choosed));
    if (findl2?.tagLabel) {
      return {
        level: menuLevel.L1,
        menu: findl2,
      };
    }
    const findl3 = menus.find((m) => (m.children ?? []).find((c) => (c.children ?? []).find((d) => d.choosed)));
    if (findl3?.tagLabel) {
      return {
        level: menuLevel.L2,
        menu: findl3,
      };
    }
    return {
      level: menuLevel.L0,
      menu: {
        id: currentChoosedMenuId(modalType.LORA),
      },
    };
  }, [menus]);

  const [isInScrolling, setIsInScrolling] = useState(0); // >0 代表content在滚动中
  // TODO: menu切换content区域要滚动到顶部
  return (
    <RndWrapper isShowCloseBtn={true} offsetX={100}>
      <ModalLayout
        sideBar={<LoraSideBar menus={menus} setMenus={setMenus} modelType={modalType.LORA} />}
        title={translate('model_window_title_lora')}
      >
        <div className="bg-white py-4 h-full cursor-default overflow-hidden flex flex-col">
          <Header modelType={modalType.LORA} menus={menus} setMenus={setMenus} menuPath={menuPath} className={'pr-4'} />
          <ContentWrapper modelType={modalType.LORA} menus={menus} setMenus={setMenus} menuPath={menuPath} />
        </div>
      </ModalLayout>
    </RndWrapper>
  );
});
export default LoraModels;
